export default __webpack_public_path__ + "static/media/Novatti PNG.7189fccd.png";